// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-content ol,\n.main-content ul {\n  padding: revert;\n  list-style: revert;\n}\nol[type='upper-alpha'] {\n  list-style-type: upper-alpha;\n}\nol[type='lower-alpha'] {\n  list-style-type: lower-alpha;\n}\nol[type='upper-roman'] {\n  list-style-type: upper-roman;\n}\nol[type='lower-roman'] {\n  list-style-type: lower-roman;\n}\nol[type='number'] {\n  list-style-type: decimal;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
